import * as React from "react";
import "./style.scss";
import background from  "../../images/parallaxbanner.png";
import {useEffect} from "react";


export default function Parallax (props){
    let {children,className,...rest} = props;
    return <section  className={`${className} parallax`}>
            {children}
                <span {...rest} className="fixed-background"/>
            </section>
}
